import { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGeneralExams } from '../lib/api';

export function ExamsPage() {
  const navigate = useNavigate();
  const { data: exams, isLoading } = useGeneralExams();

  // Scroll to top on mount
  useEffect(() => { window.scrollTo(0, 0); }, []);

  const sorted = useMemo(
    () => [...(exams?.exams ?? [])].sort((a, b) => a.code.localeCompare(b.code)),
    [exams?.exams],
  );

  if (isLoading) return <div className="flex items-center justify-center min-h-[60vh] text-slate-500">Loading...</div>;

  return (
    <div className="max-w-lg mx-auto pb-20 space-y-3">
      <h1 className="text-xl font-bold text-squishy-dark">Exams</h1>
      <p className="text-xs text-slate-500">Choose an exam to start studying.</p>
      <div className="grid grid-cols-3 sm:grid-cols-4 gap-2">
        {sorted.map((e) => (
          <button
            key={e.id}
            onClick={() => navigate(`/exam/${e.id}`)}
            className="bg-white border border-slate-200 rounded-xl px-2 py-3 text-center hover:border-squishy-primary hover:shadow-sm transition-all active:scale-[0.97]"
          >
            <div className="text-sm font-bold text-squishy-dark leading-tight">{e.code}</div>
            <div className="text-[10px] text-slate-400 mt-0.5 line-clamp-1">{e.name}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
